<div class="row" height="{200}px;" style="margin-left:10px;">
  <div class="" style="padding:0px">
    <div class="col">
      <div class="small-text">
        <div class="small-rect-1" style="float:left;">◯</div>
        <div style="overflow:hidden;">&nbsp; Adressable market size</div>
      </div>

      <div class="small-text">
        <img style="float:left;" class="funnel" src="/static/img/icons/legend_tortenstueck.png" alt="background image" />
        <div style="overflow:hidden;">&nbsp; Market share act</div>
      </div>

      <div class="small-text">
        <img style="float:left;" class="funnel" src="/static/img/icons/legend_donut_stueck.png" alt="background image" />
        <div style="overflow:hidden;">&nbsp; Market share target (end of year)</div>
      </div>

      <div class="small-text" style="padding-top:20px;">
        <div class="small-rect-1" style="float:left;" />
        <div style="overflow:hidden; color:#393939;">&nbsp; Market share act (%)</div>
      </div>

      <div class="small-text">
        <div class="small-rect-1" style="float:left;" />
        <div style="overflow:hidden; color:#4299b0;">&nbsp; Market share target (%)</div>
      </div>

      <div class="small-text">
        <div class="small-rect-1" style="float:left;" />
        <div style="margin-top: 33px; overflow:hidden; color:#4299b0;">
          &nbsp; Progress in market shares (=Market share/Market share target)
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .small-text {
    font-size: 9px;
  }

  .small-rect-1 {
    width: 10px;
    height: 10px;
    padding: 0px;
  }

  .small-rect-2 {
    width: 10px;
    height: 10px;
    padding: 0px;
  }

  img {
    width: 10px;
    height: 10px;
  }
</style>
